:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
  --border-radius: var(--sl-border-radius, 0.5rem);
  --sportsline-pick-card-header-border-radius: var(--border-radius) var(--border-radius) 0 0;
}

sportsline-chip {
  margin-left: auto;
}

.sportsline-free-expert-pick-selection {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
}

.sportsline-free-expert-pick-selection-content-header {
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 1.5rem;
  gap: 0.5rem;
}

.sportsline-free-expert-pick-selection-content {
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.sportsline-free-expert-pick-selection-content-header-header-details {
  color: var(--text-secondary-color);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 1;
  text-transform: uppercase;
}
